export const MonthEndStatusPolicy = ({
    STATUS_NEW: "NEW",
    STATUS_WIP: "WIP",
    STATUS_ERROR: "ERROR",
    STATUS_CLOSED: "CLOSED",
    STATUS_PROCESSING: "PROCESSING",
    STATUS_GENERATED: "GENERATED",
    STATUS_FINALIZED: "FINALIZED",
})